import "../rentaroomstyle.css";

export default function RentARoomSiparisler() {
  return (
    <div className="rar-page">
      <div style={{ marginBottom: 20 }}>
        <h4 className="rar-page-title">
          <i className="bi bi-bag-check-fill me-2" style={{ color: "#3b82f6" }}></i>Siparişler
        </h4>
        <p className="rar-page-subtitle">Tüm siparişleri buradan takip edebilirsiniz.</p>
      </div>

      <div className="rar-empty-card">
        <i className="bi bi-bag" style={{ fontSize: "2.5rem", display: "block", marginBottom: 12 }}></i>
        <p style={{ margin: 0, fontSize: "0.9rem" }}>Henüz sipariş bulunmuyor.</p>
      </div>
    </div>
  );
}
